import { useState } from 'react';
import Container from '../../../core/components/atoms/Container';
import Tabs from '../components/tabs';
import TabFlashcards from '../components/tab-flashcards';
import DeckFlashcards from '../components/deck-flashcards';
import { Onboarding } from '../components/onboarding';

const MemoryPage = () => {
  const [activeKey, setActiveKey] = useState('deck');

  return (
    <Container>
      <Onboarding />
      <div className='flex flex-col items-center justify-center'>
        <Tabs
          onChange={(key) => setActiveKey(key)}
          activeKey={activeKey}
          items={[
            { label: 'Deck', key: 'deck', children: <DeckFlashcards /> },
            {
              label: <i>Flashcards</i>,
              key: 'flashcards',
              children: <TabFlashcards />,
            },
          ]}
        />
      </div>
    </Container>
  );
};

export default MemoryPage;
